"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalItem = exports.LocalItem = void 0;
function LocalItem(key, version = 0) {
    return {
        put: item => putLocalItem(key, item, version),
        get: () => getLocalItem(key, version),
    };
}
exports.LocalItem = LocalItem;
function getLocalItem(key, version = 0) {
    try {
        const versionedItem = JSON.parse(window.localStorage.getItem(key));
        if (versionedItem.version === version) {
            return versionedItem.item;
        }
        else {
            return null;
        }
    }
    catch (e) {
        // TODO - Send error to server?
        return null;
    }
}
exports.getLocalItem = getLocalItem;
function putLocalItem(key, item, version = 0) {
    const versionedItem = {
        version,
        item,
    };
    window.localStorage.setItem(key, JSON.stringify(versionedItem));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZWRMb2NhbFN0b3JhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2Jyb3dzZXIvdHlwZWRMb2NhbFN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBVUEsU0FBZ0IsU0FBUyxDQUFJLEdBQVcsRUFBRSxVQUFrQixDQUFDO0lBQzNELE9BQU87UUFDTCxHQUFHLEVBQUUsSUFBSSxDQUFDLEVBQUUsQ0FBQyxZQUFZLENBQUksR0FBRyxFQUFFLElBQUksRUFBRSxPQUFPLENBQUM7UUFDaEQsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLFlBQVksQ0FBSSxHQUFHLEVBQUUsT0FBTyxDQUFDO0tBQ3pDLENBQUM7QUFDSixDQUFDO0FBTEQsOEJBS0M7QUFFRCxTQUFnQixZQUFZLENBQzFCLEdBQVcsRUFDWCxVQUFrQixDQUFDO0lBRW5CLElBQUk7UUFDRixNQUFNLGFBQWEsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUM5QixNQUFNLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FDUixDQUFDO1FBQzNCLElBQUksYUFBYSxDQUFDLE9BQU8sS0FBSyxPQUFPLEVBQUU7WUFDckMsT0FBTyxhQUFhLENBQUMsSUFBSSxDQUFDO1NBQzNCO2FBQU07WUFDTCxPQUFPLElBQUksQ0FBQztTQUNiO0tBQ0Y7SUFBQyxPQUFPLENBQUMsRUFBRTtRQUNWLCtCQUErQjtRQUMvQixPQUFPLElBQUksQ0FBQztLQUNiO0FBQ0gsQ0FBQztBQWpCRCxvQ0FpQkM7QUFFRCxTQUFTLFlBQVksQ0FDbkIsR0FBVyxFQUNYLElBQU8sRUFDUCxVQUFrQixDQUFDO0lBRW5CLE1BQU0sYUFBYSxHQUEwQjtRQUMzQyxPQUFPO1FBQ1AsSUFBSTtLQUNMLENBQUM7SUFDRixNQUFNLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxhQUFhLENBQUMsQ0FBQyxDQUFDO0FBQ2xFLENBQUMifQ==